// Library methods
import { useContext, useMemo } from "react";

// Components
import ReportInfo from "./ReportInfo";
import EyeReportContent from "../../../../components/UI/EyeReportContent";
import VisualAcuityGraph from "../../../../components/UI/VisualAcuityGraph";
import BaileyLovieGraph from "../../../../components/UI/VisualAcuityGraph/BaileyLovieGraph";

// Utilities
import { ReportDataContext } from "../../../../contexts/ReportDataContext";
import { ReportEachSectionContext } from "../../../../contexts/CommentContext";
import { algorithmTypes, examCardEnums } from "../../../../enums";

const EyeReport = () => {
  const { exam } = useContext(ReportDataContext);
  const { examReport } = useContext(ReportEachSectionContext);

  const examAlgorithm = useMemo(() => {
    const sectionName = examCardEnums.VISUAL_ACUITY.sectionName;
    return exam?.[sectionName]?.[0]?.algorithm;
  }, [exam]);

  if (!examReport) return null;

  // build the report content
  return (
    <div className="retinalogik-section retinalogik-report">
      {examAlgorithm === algorithmTypes.TUMBLING_E && (
        <EyeReportContent
          ReportInfo={<ReportInfo />}
          ExamGraph={<VisualAcuityGraph examData={examReport} />}
        />
      )}
      {examAlgorithm === algorithmTypes.LANDOLT_C && (
        <EyeReportContent
          ReportInfo={<ReportInfo />}
          ExamGraph={
            <VisualAcuityGraph examData={examReport} isLandoltC={true} />
          }
        />
      )}
      {examAlgorithm === algorithmTypes.SNELLEN && (
        <EyeReportContent
          ReportInfo={<ReportInfo />}
          ExamGraph={
            <VisualAcuityGraph examData={examReport} isSnellen={true} />
          }
        />
      )}
      {examAlgorithm === algorithmTypes.BAILEY_LOVIE && (
        <EyeReportContent
          ReportInfo={<ReportInfo />}
          ExamGraph={<BaileyLovieGraph examData={examReport} />}
        />
      )}
    </div>
  );
};

export default EyeReport;
